
import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import { Button, Card } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import shoppingCartService from '../../../../services/Public/shoppingCart.service';
import LoadingSpinner from '../../../Shared/GenericComponents/LoadingSpinner';

function PaymentFailedPage() {
    const push = useNavigate()
    const [hasLoaded, setHasLoaded] = useState(false);

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        shoppingCartService.postFailOnlinePayment(params.token, params.r).then((response) => {
            if (response.data)
                setHasLoaded(true)
        })
    }, [])
    const returnToCart = () => {
        push('/firm/shoppingcart')
    }
    return (
        <Card>
            <Card.Body style={{ textAlign: 'center' }}>
                {hasLoaded ?
                    <>
                        <p className="colorRed">
                            <FaTimes style={{ height: '10em', width: '10em' }} />
                            <h3>Payment Failed</h3>
                        </p>
                        <h5 className="mb-3">Looks like we encountered an error. Please try again. If you continue to have issues, try another payment method.</h5>
                        <Button onClick={returnToCart}>Back to Cart</Button>
                    </> : <LoadingSpinner />}
            </Card.Body>
        </Card>

    );
}

export default PaymentFailedPage;